import { cn } from "@/lib/cn";

interface MockBadgeProps {
  label: string;
  className?: string;
}

export const MockBadge = ({ label, className }: MockBadgeProps) => (
  <span
    data-testid="mock-badge"
    className={cn(
      "inline-flex items-center rounded-sm border border-dashed border-amber-500/60 bg-amber-500/10 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber-700 dark:text-amber-400",
      className,
    )}
  >
    {label}
  </span>
);
